import { userService } from '../service';
export function Index() {
  return userService.get('MesPadClientMenus/Index');
}
export function LoadData(query) {
  return userService.get('MesPadClientMenus/LoadData', {
    params: query
  });
}
export function ItemIsByUsed(id) {
  return userService.get('MesPadClientMenus/ItemIsByUsed', {
    params: {
      id: id
    }
  });
} // 保存数据

export function SaveData(data) {
  return userService.post('MesPadClientMenus/SaveData', data);
}
export function AddOrModify() {
  return userService.get('MesPadClientMenus/AddOrModify');
}
export function DeleteOneById(id) {
  return userService.post('MesPadClientMenus/DeleteOneById', id);
}
export function LoadDataByRoleId(roleId) {
  return userService.get('MesPadClientMenus/LoadDataByRoleId', {
    params: {
      roleId: roleId
    }
  });
}
export function SavePadRoleData(data) {
  return userService.post('MesPadClientMenus/SavePadRoleData', data);
}